import React, { useEffect, useState } from 'react'
import { Stack, Text, Flex, Box, Button  } from '@chakra-ui/react'

import { IDashboardCollaborator } from 'services/IApi.d'
import { ChevronDownIcon } from '@chakra-ui/icons'

interface IAdministratorProps {
  person: IDashboardCollaborator[]
}

// Administradores
const PersonAdministrator = ({ person }: IAdministratorProps) => {
  const minPersons = 3
  const [expanded, setExpanded] = useState<boolean>(false);
  const [countPersons, setCountPersons] = useState<number>(minPersons);

  useEffect(() => {
     (expanded) ?  setCountPersons(person.length) :    setCountPersons(3)
  }, [expanded]);

  return (  
  <>
    {person.slice(0,countPersons).map(({ name, lastName, documentNumber, documentType, nationality }, indexPerson) => (
        <Stack
          data-testid={`personAdmin-${indexPerson}`}
          key={`personAdmin-${documentNumber}`}
          display='flex'
          direction='row'
          p='6px 12px'
          alignItems='center'
          borderBottom='solid 1px #ddd'
          _last={{ borderBottomWidth: 0 }}
          flexBasis='auto'
        >
          <Flex flex={1} data-testid={`personAdmin-${documentNumber}`} key={`administrator-${documentNumber}`}>
            <Flex flex={1} justifyContent='start'>
              <Text data-testid={`personAdmin-${documentNumber}-name`} textStyle='titleSm' fontWeight='400' size='2xs' line-height='md' color='secondary.500'>{name} {lastName}</Text>
            </Flex>
            <Flex flex={1} justifyContent='end'>
              <Text data-testid={`personAdmin-${documentNumber}-cuit`} textAlign={'right'} textStyle='bodyMd' fontWeight='400' size='2xs' line-height='md' color='secondary.900'>{nationality === 'AR' ? 'CUIL' : documentType} {documentNumber}</Text>
            </Flex>
          </Flex>
        </Stack>
    ))}
    {person.length > minPersons &&
      <Box data-testid='personAdmin-expand' flex={1}  textAlign={'center'}>
        <Button data-testid='personAdmin-expand-buttom'  variant='primary-text' size={'md'} onClick={()=>setExpanded(!expanded)} rightIcon={<ChevronDownIcon boxSize={'20px'}/>}>
          {expanded ? 'Ver menos': 'Ver más'}
        </Button>
      </Box>
    }
  </>
)}

export default PersonAdministrator
